import { Component } from '@angular/core';

@Component({
    selector: 'cb-integration-logs',
    templateUrl: './integration-logs.component.html',
    styleUrls: ['./integration-logs.component.scss'],
    standalone: false
})
export class IntegrationLogsComponent {
}
